import type { MarketplaceSkill } from "./skill-market-types"

// 内置分类的 mock 技能（安全审计/漏洞扫描/合规/应急响应/数字取证）
// 暂时注释掉测试数据，保留代码以便后续恢复
// const BUILTIN_MOCK_SKILLS: MarketplaceSkill[] = [
//   {
//     id: "builtin-web-security-audit",
//     name: "web-security-audit",
//     display_name: "Web 安全审计",
//     description: "自动化 Web 应用安全审计，检测 OWASP Top 10 漏洞，生成安全报告",
//     category: "security-audit",
//     tags: ["owasp", "web", "xss", "sql-injection"],
//     version: "1.0.0",
//     author: "SSAI Team",
//     install_count: 0,
//     rating: 4.5,
//     review_status: "approved",
//     source_type: "builtin",
//     is_installed_global: false,
//     is_installed_project: false,
//     time_created: Date.now() - 86400000 * 5,
//     time_updated: Date.now() - 86400000 * 5,
//   },
//   {
//     id: "builtin-vuln-scanner",
//     name: "vuln-scanner",
//     display_name: "漏洞扫描器",
//     description: "扫描系统和应用已知漏洞，集成 CVE 数据库查询和依赖分析",
//     category: "vulnerability-scan",
//     tags: ["cve", "dependency", "scan"],
//     version: "1.0.0",
//     author: "SSAI Team",
//     install_count: 0,
//     rating: 4.6,
//     review_status: "approved",
//     source_type: "builtin",
//     is_installed_global: false,
//     is_installed_project: false,
//     time_created: Date.now() - 86400000 * 4,
//     time_updated: Date.now() - 86400000 * 4,
//   },
//   {
//     id: "builtin-compliance-check",
//     name: "compliance-check",
//     display_name: "合规检查",
//     description: "对照安全标准（GDPR、ISO 27001、SOC 2 等）进行合规审计，生成差距分析报告",
//     category: "compliance",
//     tags: ["gdpr", "iso27001", "soc2", "audit"],
//     version: "1.0.0",
//     author: "SSAI Team",
//     install_count: 0,
//     rating: 4.3,
//     review_status: "approved",
//     source_type: "builtin",
//     is_installed_global: false,
//     is_installed_project: false,
//     time_created: Date.now() - 86400000 * 3,
//     time_updated: Date.now() - 86400000 * 3,
//   },
//   {
//     id: "builtin-incident-response",
//     name: "incident-response",
//     display_name: "应急响应",
//     description: "安全事件应急处理流程，包括检测、遏制、根除和恢复，生成事件报告",
//     category: "incident-response",
//     tags: ["breach", "containment", "recovery"],
//     version: "1.0.0",
//     author: "SSAI Team",
//     install_count: 0,
//     rating: 4.7,
//     review_status: "approved",
//     source_type: "builtin",
//     is_installed_global: false,
//     is_installed_project: false,
//     time_created: Date.now() - 86400000 * 2,
//     time_updated: Date.now() - 86400000 * 2,
//   },
//   {
//     id: "builtin-digital-forensics",
//     name: "digital-forensics",
//     display_name: "数字取证",
//     description: "数字取证调查，证据收集、保存、分析和报告，支持磁盘镜像和内存分析",
//     category: "forensics",
//     tags: ["evidence", "disk-image", "memory-analysis"],
//     version: "1.0.0",
//     author: "SSAI Team",
//     install_count: 0,
//     rating: 4.4,
//     review_status: "approved",
//     source_type: "builtin",
//     is_installed_global: false,
//     is_installed_project: false,
//     time_created: Date.now() - 86400000,
//     time_updated: Date.now() - 86400000,
//   },
//   {
//     id: "builtin-code-security-review",
//     name: "code-security-review",
//     display_name: "代码安全审查",
//     description: "源代码安全审查，静态分析和不安全编码模式识别，提供修复建议",
//     category: "security-audit",
//     tags: ["sast", "code-review", "secure-coding"],
//     version: "1.0.0",
//     author: "SSAI Team",
//     install_count: 0,
//     rating: 4.8,
//     review_status: "approved",
//     source_type: "builtin",
//     is_installed_global: false,
//     is_installed_project: false,
//     time_created: Date.now(),
//     time_updated: Date.now(),
//   },
// ]

// 「其他」分类 50 条测试假数据：用于验证分页/滚动加载与分类计数
// PAGE_SIZE=20，50 条可测 3 页（20+20+10）
// 暂时注释掉测试数据，保留代码以便后续恢复
// const OTHER_MOCK_SKILLS: MarketplaceSkill[] = Array.from({ length: 50 }, (_, i) => {
//   const n = i + 1
//   return {
//     id: `mock-other-${n}`,
//     name: `other-skill-${n}`,
//     display_name: `测试技能 ${n}`,
//     description: `「其他」分类测试技能 ${n}，用于验证分页与分类计数`,
//     category: "other",
//     tags: ["test", "other"],
//     version: "1.0.0",
//     author: "Mock Generator",
//     install_count: 0,
//     rating: 4.0,
//     review_status: "approved",
//     source_type: "builtin",
//     is_installed_global: false,
//     is_installed_project: false,
//     time_created: Date.now() - 86400000 * n,
//     time_updated: Date.now() - 86400000 * n,
//   }
// })

// mock 测试数据已全部注释；导出空数组保持类型与引用不变
export const MOCK_SKILLS: MarketplaceSkill[] = []
